import { UserListState } from "./UserList-State";

export default function userListReducer(state = UserListState, action) {
  let { data } = { ...state };
  let { name, value } = action;

  switch (action.type) {
    case "TOGGLE-USER-LIST-FILTER":
      let toggle = true;
      if (toggle) {
        if (name === "limit") {
          data.params.page = 1;
        }
        data.params[name] = value;
      }
      data.params[name] = value;
      // if ( name === `sort_id` ) {
      //   if ( data.params.sort_id === value ) {
      //     data.params.sort_order = data.params.sort_order === `desc` ? `asc` : `desc`
      //   }
      // }
      if (name === `sort_by`) {
        if (data.params.sort_by === value) {
          data.params.sort_order =
            data.params.sort_order === `desc` ? `asc` : `desc`;
        }
      }
      return { ...state, data };

    case "TOGGLE-RESET-USERS":
      data.params.page = 1;
      data.params.q = "";
      data.payload.initialLoading = true;
      return { ...state, data };

    default:
      return state;
  }
}
